<template>
  <v-container>
    <unattended />

    <v-divider class="mb-8 mx-lg-6 d-md-block d-none"></v-divider>

    <devices />
  </v-container>
</template>

<script>
import Devices from './Devices/Devices.vue'
import Unattended from './Unattended/Unattended.vue'

export default {
  components: { Unattended, Devices },
  name: 'Index',
}
</script>
